import Marquee from "react-fast-marquee";
import { useLang } from "../i18n/LanguageContext";

const clients = [
  "Netflix",
  "Coca-Cola",
  "Heineken",
  "IKEA",
  "Samsung",
  "KFC",
  "Volkswagen",
  "Mercedes-Benz",
  "Nissan",
  "Paramount",
  "Nestlé",
  "Heinz",
  "Etihad",
  "Mountain Dew",
  "Renault",
  "Kellogg's",
  "BP",
  "EDP",
  "Galp",
  "Petrobras",
  "Legoland",
  "Leroy Merlin",
  "O Boticário",
];

export default function Clients() {
  const { t } = useLang();
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative py-24 md:py-32 border-b border-[#1a1a1a] overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 mb-12 md:mb-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#ff4500]">
                {t.clients.label}
              </span>
              <span className="h-[1px] w-16 bg-[#262626]" />
            </div>
            <h2
              data-testid="clients-heading"
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight"
            >
              {t.clients.headingA}{" "}
              <span className="italic text-[#ff4500]">{t.clients.headingB}</span>.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <p className="text-neutral-400 text-base md:text-lg leading-relaxed">
              {t.clients.intro}
            </p>
          </div>
        </div>
      </div>

      <div className="marquee-mask">
        <Marquee gradient={false} speed={45} pauseOnHover>
          {clients.map((c) => (
            <div
              key={c}
              data-testid={`client-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="flex items-center gap-8 px-8 group cursor-default"
            >
              <span className="font-serif text-4xl md:text-6xl font-light tracking-tight text-white group-hover:text-[#ff4500] transition-colors duration-500 whitespace-nowrap">
                {c}
              </span>
              <span className="text-[#ff4500] text-2xl md:text-4xl">✦</span>
            </div>
          ))}
        </Marquee>
      </div>

      <div className="marquee-mask mt-6">
        <Marquee gradient={false} speed={35} direction="right" pauseOnHover>
          {clients
            .slice()
            .reverse()
            .map((c) => (
              <div
                key={`r-${c}`}
                className="flex items-center gap-8 px-8 group cursor-default"
              >
                <span className="font-serif italic text-3xl md:text-5xl font-light tracking-tight text-neutral-500 group-hover:text-white transition-colors duration-500 whitespace-nowrap">
                  {c}
                </span>
                <span className="text-neutral-700 text-xl md:text-3xl">/</span>
              </div>
            ))}
        </Marquee>
      </div>
    </section>
  );
}
